import { keepPreviousData } from '@tanstack/react-query';
import { trpc } from '@/shared/api';

interface MyOrdersQueryInput {
  readonly page: number;
}

/**
 * 내 주문 목록(orders.listMine, 주문 설계 §8-2) — 최신순 페이지 번호 페이지네이션, 페이지 크기는 서버 기본값.
 * 페이지를 바꾸는 동안 이전 페이지를 자리표시자로 유지해 표가 비지 않는다.
 */
export const useMyOrdersQuery = ({ page }: MyOrdersQueryInput) =>
  trpc.orders.listMine.useQuery({ page }, { placeholderData: keepPreviousData });
